// Commission is excluded so orders saved before commission was charged keep their stored amount
const ORDER_EXPENSE_KEYS = [
    "creditCard",
    "freeGive",
    "crane",
    "voucher",
    "drawing",
    "sponsor",
    "addon",
    "threedDrawing",
    "snSstCn",
    "swSstCn",
    "sstCn",
    "accessoryCosting",
];

const PRODUCT_SHARE_OF_TOTAL = 0.295566;
const SST_RATE = 0.05;

const roundMoney = (value) =>
    Math.round((value + Number.EPSILON) * 100) / 100;

const calculateOrderTotalExpenses = (expenses) => {
    if (!expenses || typeof expenses !== "object") return 0;
    return ORDER_EXPENSE_KEYS.reduce(
        (sum, key) => sum + (parseFloat(expenses[key] || 0) || 0),
        0,
    );
};

export const resolveInvoiceTotalAmount = (order) => {
    let cartTotal = 0;
    if (Array.isArray(order?.products)) {
        for (const product of order.products) {
            cartTotal +=
                (parseFloat(product.price) || 0) *
                (parseFloat(product.amount) || 0);
        }
    }

    const expensesTotal = calculateOrderTotalExpenses(order?.expenses);
    const storedAmount = parseFloat(order?.amount || 0) || 0;
    const amountWithExpenses = cartTotal + expensesTotal;

    if (storedAmount > 0) {
        if (expensesTotal > 0 && storedAmount < amountWithExpenses - 0.01) {
            return amountWithExpenses;
        }
        return storedAmount;
    }

    return amountWithExpenses;
};

/**
 * Product charge (SST-able) vs labour / installation charge (no SST),
 * matching the split printed on the invoice.
 */
export const getInvoiceSalesBreakdown = (order, totalAmount = resolveInvoiceTotalAmount(order)) => {
    if (order?.sstIncluded !== true) {
        return {
            totalAmount,
            productUnitPrice: null,
            productSst: 0,
            productAmountIncl: null,
            labourCharge: roundMoney(totalAmount),
        };
    }

    const productUnitPrice = roundMoney(totalAmount * PRODUCT_SHARE_OF_TOTAL);
    const productSst = roundMoney(productUnitPrice * SST_RATE);
    const productAmountIncl = roundMoney(productUnitPrice * (1 + SST_RATE));
    return {
        totalAmount,
        productUnitPrice,
        productSst,
        productAmountIncl,
        labourCharge: roundMoney(totalAmount - productAmountIncl),
    };
};
